import React from 'react';
import c from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import s from './SocialButtonBase.scss';
const SocialButtonBase = ({ biData, className, labelClassName, onClick, children })=>{
    return /*#__PURE__*/ React.createElement(BiButton, {
        className: c(s['root'], s['updated-ui'], className),
        biData: biData,
        onClick: onClick,
        type: "button"
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['label'], labelClassName)
    }, children));
};
SocialButtonBase.displayName = 'SocialButtonBase';
export default SocialButtonBase;
